import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AppShell } from "@/components/AppShell";
import { WellbeingDialog } from "@/components/WellbeingDialog";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import History, { DigestPage } from "@/pages/History";
import Connections from "@/pages/Connections";
import Homework from "@/pages/Homework";
import Ask from "@/pages/Ask";
import Welcome from "@/pages/Welcome";
import Admin from "@/pages/Admin";
import Revise, { RevisePack } from "@/pages/Revise";
import PublicPack from "@/pages/PublicPack";
import Week from "@/pages/Week";
import Messages from "@/pages/Messages";
import Contact from "@/pages/Contact";
import DayLog from "@/pages/DayLog";
import SubjectTimeline from "@/pages/SubjectTimeline";
import Conduct from "@/pages/Conduct";
import PaymentResult from "@/pages/PaymentResult";
import Groups from "@/pages/Groups";
import GroupPage from "@/pages/GroupPage";
import Quiz from "@/pages/Quiz";
import Plan from "@/pages/Plan";
import LessonNotes from "@/pages/LessonNotes";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/p/:shareId" element={<PublicPack />} />
      <Route element={<AppShell />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/history" element={<History />} />
        <Route path="/digest/:id" element={<DigestPage />} />
        <Route path="/connections" element={<Connections />} />
        <Route path="/homework" element={<Homework />} />
        <Route path="/ask" element={<Ask />} />
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/revise" element={<Revise />} />
        <Route path="/revise/:id" element={<RevisePack />} />
        <Route path="/week" element={<Week />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/messages/:tid" element={<Messages />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/daylog" element={<DayLog />} />
        <Route path="/daylog/subject/:name" element={<SubjectTimeline />} />
        <Route path="/conduct" element={<Conduct />} />
        <Route path="/payment/success" element={<PaymentResult />} />
        <Route path="/payment/cancel" element={<PaymentResult />} />
        <Route path="/groups" element={<Groups />} />
        <Route path="/groups/:gid" element={<GroupPage />} />
        <Route path="/quiz/:packId" element={<Quiz />} />
        <Route path="/plan" element={<Plan />} />
        <Route path="/notes" element={<LessonNotes />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-center" richColors theme="light" />
        <WellbeingDialog />
      </AuthProvider>
    </BrowserRouter>
  );
}
